'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Button } from '@/ui/buttons/button/Button.client'
import { Icon } from '@/ui/icons/icon/Icon'
import { useDefinitionListSync } from '@/ui/lists/definition-list/DefinitionListProvider.client'
import { Button as AriaButton } from 'react-aria-components'

type EquivalentProductSeeMoreButtonProps = {
  /** Is the button displayed as a Link ? */
  asLink?: boolean
}

export function EquivalentProductSeeMoreButton({
  asLink = false,
}: EquivalentProductSeeMoreButtonProps) {
  const sync = useDefinitionListSync()
  const { t } = useTranslation(['productPage', 'generic'])

  if (!sync) {
    return null
  }

  const { toggleFullDisplay, isFullDisplay } = sync
  const text = isFullDisplay ? t('generic:actions.seeLess') : t('generic:actions.seeMore')

  if (asLink) {
    return (
      <AriaButton
        onPress={toggleFullDisplay}
        preventFocusOnPress
        // FIXME: replace hover: by useHover()
        // eslint-disable-next-line dc/no-hover
        className="w-full font-bold underline outline-none hover:normal-case hover:no-underline"
      >
        {text}
      </AriaButton>
    )
  }

  return (
    <Button
      size="md"
      iconRight={isFullDisplay ? <Icon.CircleChevronUp /> : <Icon.CircleChevronDown />}
      onPress={toggleFullDisplay}
      variant="quaternary"
    >
      {text}
    </Button>
  )
}
